import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";

import type { AppDispatch } from "./state/rootStore";
import type { RootState } from "./state/rootReducer";

// Use these typed hooks throughout the app instead of plain `useDispatch` and `useSelector`
// This provides proper typing for thunk actions and state access
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
